import { HTML_ELEMENTS } from "../constants/html-constants.es6.js";
import Element from "@js/core/element.es6.js";
import Field from "@js/core/field.es6.js";

export default class LinkField extends Field {
  get anchor() {
    return new Element({
      parentElement: this,
      selector: `> ${HTML_ELEMENTS.ANCHOR}:first-of-type`,
    });
  }
}
